import { inherits as _inherits, createSuper as _createSuper, classCallCheck as _classCallCheck, defineProperty as _defineProperty, assertThisInitialized as _assertThisInitialized, createClass as _createClass, objectWithoutProperties as _objectWithoutProperties, extends as _extends, typeof as _typeof, objectSpread2 as _objectSpread2, toConsumableArray as _toConsumableArray } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import { useFormControl, TextField, CircularProgress, Autocomplete } from '@mui/material';
import React from 'react';
import { debounce } from '../../../cinnamon-core/es/modules/utility/debounce.js';

var _excluded = ["label", "search", "allowAdditions", "required", "error", "inputRef", "inputProps", "autoFocus", "inputDebounce", "onChange"],
    _excluded2 = ["disabled", "required", "error"];

/**
 * Basic combo-box implementation based on MUI autocomplete
 */
var ComboBox = /*#__PURE__*/function (_React$Component) {
  _inherits(ComboBox, _React$Component);

  var _super = _createSuper(ComboBox);

  function ComboBox(_props) {
    var _this;

    _classCallCheck(this, ComboBox);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "isValidValue", function (value) {
      return Array.isArray(value) ? value.length > 0 : value !== null && value !== undefined && value !== "";
    });

    _defineProperty(_assertThisInitialized(_this), "getOptions", function () {
      var value = _this.props.value;
      var selectedOptions = Array.isArray(value) ? value.filter(function (x) {
        return _typeof(x) === "object";
      }) : !!value && _typeof(value) === "object" ? [value] : []; // add current selection as hidden options to avoid unknown value warnings

      var hiddenOptions = selectedOptions.map(function (o) {
        return _objectSpread2(_objectSpread2({}, o), {}, {
          hidden: true
        });
      });
      return [].concat(_toConsumableArray(_this.props.options), _toConsumableArray(hiddenOptions)).filter(function (o, idx, arr) {
        return o.hasOwnProperty("value") && arr.findIndex(function (x) {
          return x.value === o.value;
        }) === idx;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChangeDebounced", void 0);

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event, value, reason) {
      if (_this.props.allowAdditions && !_this.props.multiple && reason === "input") {
        _this.onChangeDebounced ? _this.onChangeDebounced(event, value, reason) : _this.onChange(event, value, reason);
      }

      if (_this.props.onInputChange) {
        _this.props.onInputChange(event, value, reason);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (event, value, reason, details) {
      _this.setState({
        selectedValue: value
      });

      var onChange = _this.props.onChange;
      if (_this.onChangeDebounced) _this.onChangeDebounced.cancel();
      if (onChange) onChange(event, value, reason, details);
    });

    _defineProperty(_assertThisInitialized(_this), "getOptionLabel", function (o) {
      return _this.props.getOptionLabel ? _this.props.getOptionLabel(o) : _typeof(o) === "object" ? o.label || "" : o;
    });

    _defineProperty(_assertThisInitialized(_this), "renderOption", function (props, option, state) {
      if (option.hidden) return null;
      return _this.props.renderOption ? _this.props.renderOption(props, option, state) : /*#__PURE__*/React.createElement("li", _extends({}, props, {
        key: option.value
      }), _this.getOptionLabel(option));
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (params) {
      var _this$props = _this.props,
          value = _this$props.value,
          label = _this$props.label,
          required = _this$props.required,
          loading = _this$props.loading,
          search = _this$props.search,
          allowAdditions = _this$props.allowAdditions,
          autoFocus = _this$props.autoFocus,
          disabled = _this$props.disabled,
          placeholder = _this$props.placeholder,
          error = _this$props.error,
          inputRef = _this$props.inputRef,
          inputProps = _this$props.inputProps;

      if (_this.props.renderInput) {
        return _this.props.renderInput(params);
      }

      var hasValue = _this.isValidValue(value);

      return /*#__PURE__*/React.createElement(TextField, _extends({}, params, {
        label: label,
        required: required,
        error: error,
        autoFocus: autoFocus,
        sx: !search && !allowAdditions ? {
          ".MuiInputBase-root": {
            cursor: disabled ? "default" : "pointer"
          },
          input: {
            cursor: disabled ? "default" : "pointer",
            caretColor: "transparent"
          }
        } : undefined,
        InputProps: _objectSpread2(_objectSpread2({}, params.InputProps), {}, {
          placeholder: hasValue ? undefined : placeholder,
          endAdornment: /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(CircularProgress, {
            color: "inherit",
            size: 20
          }) : null, params.InputProps.endAdornment)
        }),
        inputRef: inputRef,
        inputProps: _objectSpread2(_objectSpread2({}, params.inputProps), inputProps)
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "isOptionEqualToValue", function (o, v) {
      return _this.props.isOptionEqualToValue ? _this.props.isOptionEqualToValue(o, v) : o === v || o.hasOwnProperty("value") && o.value === (v === null || v === void 0 ? void 0 : v.value);
    });

    var inputDebounce = _props.inputDebounce;

    if (inputDebounce !== undefined && inputDebounce !== 0) {
      _this.onChangeDebounced = debounce(_this.onChange, inputDebounce);
    }

    return _this;
  }

  _createClass(ComboBox, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props;
          _this$props2.label;
          var search = _this$props2.search,
          allowAdditions = _this$props2.allowAdditions;
          _this$props2.required;
          _this$props2.error;
          _this$props2.inputRef;
          _this$props2.inputProps;
          _this$props2.autoFocus;
          _this$props2.inputDebounce;
          _this$props2.onChange;
          var otherProps = _objectWithoutProperties(_this$props2, _excluded);

      var selectedValue = this.state.selectedValue;
      var options = this.getOptions();
      var value = this.props.value;

      if (value) {
        // populate unknown labels where the value exists in options
        if (Array.isArray(value)) {
          if (value.some(function (v) {
            return _typeof(v) === "object" && !v.label;
          })) {
            value = value.map(function (v) {
              if (_typeof(v) === "object" && !v.label) {
                var foundOption = options.find(function (o) {
                  return _this2.isOptionEqualToValue(o, v);
                });
                if (foundOption !== null && foundOption !== void 0 && foundOption.label) return _objectSpread2(_objectSpread2({}, v), {}, {
                  label: foundOption.label
                });
              }

              return v;
            }) // exclude values where the labels couldn't be found
            .filter(function (v) {
              return _typeof(v) !== "object" || v.label;
            });
          }
        } else if (_typeof(value) === "object") {
          if (!value.label) {
            var foundOption = options.find(function (o) {
              return _this2.isOptionEqualToValue(o, value);
            }); // use found option label, hide otherwise

            value = foundOption !== null && foundOption !== void 0 && foundOption.label ? _objectSpread2(_objectSpread2({}, value), {}, {
              label: foundOption.label
            }) : null;
          }
        }
      } else if (this.props.multiple) {
        // handle possible null values
        value = [];
      }

      var inputValue = undefined;

      if (!search && !allowAdditions) {
        // prevent input text being changed
        var v = value !== undefined ? value : selectedValue;
        inputValue = !!v && typeof v !== "string" && !Array.isArray(v) ? v.label || "" : "";
      }

      return /*#__PURE__*/React.createElement(Autocomplete, _extends({
        inputValue: inputValue,
        selectOnFocus: search || allowAdditions,
        handleHomeEndKeys: false,
        filterSelectedOptions: !!this.props.multiple
      }, otherProps, {
        options: options,
        value: value,
        onChange: this.onChange,
        onInputChange: this.onInputChange,
        getOptionLabel: this.getOptionLabel,
        renderOption: this.renderOption,
        renderInput: this.renderInput,
        isOptionEqualToValue: this.isOptionEqualToValue,
        freeSolo: allowAdditions
      }));
    }
  }]);

  return ComboBox;
}(React.Component);

_defineProperty(ComboBox, "propTypes", {
  label: propTypes.node,
  search: propTypes.bool,
  allowAdditions: propTypes.bool,
  autoFocus: propTypes.bool,
  renderInput: propTypes.func,
  placeholder: propTypes.string,
  required: propTypes.bool,
  error: propTypes.bool,
  inputRef: propTypes.oneOfType([propTypes.string, propTypes.func, propTypes.object]),
  inputProps: propTypes.any,
  inputDebounce: propTypes.number,
  onChange: propTypes.func
});

_defineProperty(ComboBox, "defaultProps", {
  search: false
});

var ComboBoxFormControl = function ComboBoxFormControl(_ref) {
  var disabled = _ref.disabled,
      required = _ref.required,
      error = _ref.error,
      props = _objectWithoutProperties(_ref, _excluded2);

  var formControl = useFormControl();
  return /*#__PURE__*/React.createElement(ComboBox, _extends({}, props, {
    disabled: disabled !== null && disabled !== void 0 ? disabled : formControl === null || formControl === void 0 ? void 0 : formControl.disabled,
    required: required !== null && required !== void 0 ? required : formControl === null || formControl === void 0 ? void 0 : formControl.required,
    error: error !== null && error !== void 0 ? error : formControl === null || formControl === void 0 ? void 0 : formControl.error
  }));
};

ComboBoxFormControl.propTypes = {
  label: propTypes.node,
  search: propTypes.bool,
  allowAdditions: propTypes.bool,
  autoFocus: propTypes.bool,
  renderInput: propTypes.func,
  placeholder: propTypes.string,
  required: propTypes.bool,
  error: propTypes.bool,
  inputRef: propTypes.oneOfType([propTypes.string, propTypes.func, propTypes.object]),
  inputProps: propTypes.any,
  inputDebounce: propTypes.number,
  onChange: propTypes.func
};
var ComboBox$1 = ComboBoxFormControl;

export { ComboBox$1 as default };
